import { Component, OnInit, Input, HostListener } from '@angular/core';

import { EmbedVideoService } from 'ngx-embed-video';
import { VideoPlayerService } from '@shared/services';

@Component({
  selector: 'video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss']
})
export class VideoPlayerComponent implements OnInit {
  videoHeight = 500;
  videoLink;
  playerTitle;

  iframe_html: any;

  @HostListener('window:resize', ['$event'])
  onResize() {
    setTimeout(() => {
      this.setVideoHeight();
    }, 500);
  }

  constructor(
    private embedService: EmbedVideoService,
    private _videoPlayer: VideoPlayerService
  ) {}

  ngOnInit() {
    this.setVideoHeight();
    this._videoPlayer.video.subscribe(video => {
      this.videoLink = video;
      this.setIframeHTML(video);
    });
    this._videoPlayer.title.subscribe(title => {
      this.playerTitle = title;
    });
  }

  setVideoHeight() {
    if (window.outerWidth < 767 && window.outerWidth > 575) {
      this.videoHeight = 350;
      this.setIframeHTML(this.videoLink);
    } else if (window.outerWidth <= 575) {
      this.videoHeight = 269;
      this.setIframeHTML(this.videoLink);
    } else {
      this.videoHeight = 500;
      this.setIframeHTML(this.videoLink);
    }
  }

  setIframeHTML(link) {
    if (link) {
      this.iframe_html = this.embedService.embed(link, {
        attr: { width: '100%', height: this.videoHeight }
      });
    }
  }

  closePlayer() {
    this._videoPlayer.toggle();
  }
}
